// The flag font: country flags drawn the same everywhere, Windows included (it has no flag emoji). Twemoji flags,
// CC BY 4.0, served from the bundle (the content policy allows no font from elsewhere). Only the flag code points use
// it (unicode-range), so the text around a flag keeps its own font, and the browser downloads it at its first flag.
import fontUrl from 'country-flag-emoji-polyfill/dist/TwemojiCountryFlags.woff2?url';

export const FLAG_FAMILY = 'Twemoji Country Flags';
/** A canvas font with the flag font first (labels drawn into a texture). */
export const labelFont = (px: number): string => `bold ${px}px "${FLAG_FAMILY}", system-ui, sans-serif`;

let face: FontFace | null = null;

/** Registers the flag font with the page, once. The CSS font stacks name it first. */
export function registerFlagFont(): FontFace | null {
  if (face || typeof FontFace === 'undefined' || typeof document === 'undefined' || !document.fonts) return face;
  face = new FontFace(FLAG_FAMILY, `url(${fontUrl}) format('woff2')`, { unicodeRange: 'U+1F1E6-1F1FF', display: 'swap' });
  document.fonts.add(face);
  return face;
}

/**
 * Waits for the flag font, at most `ms`, when one of the riders shows a flag: a canvas does not wait for a font, and
 * rider labels are painted once. Without the font a label shows the two letters of the code, still readable.
 */
export async function flagsReady(riders: readonly { country?: string | null }[], ms = 2000): Promise<void> {
  if (!riders.some(r => r.country)) return;
  const f = registerFlagFont();
  if (!f || f.status === 'loaded') return;
  let timer: ReturnType<typeof setTimeout> | undefined;
  await Promise.race([f.load().catch(() => undefined), new Promise(r => { timer = setTimeout(r, ms); })]);
  clearTimeout(timer);
}
